<template>
  <div id='sources-content'>
    <div id="source-list" :class="{ minimise: activeSource }">
      <app-list
          :list-type=listType
          :fields=searchFields
          :records="sourcesData"
          :records-pagination="sourcesPagination"
          :displayColumns=displayColumns
          :allowAdd=true
          :allowAdvancedSearch=true
          :isListBusy="sources.isBusy"
          :searchModel="searchModel"
          :isItemClickable="true"
          :activeRecord="activeSource"
          groupBy="category"
          @updateSearchModel="updateSearchModel"
          @onSearchSubmit="onSearchSubmit"
          @onListAddClick="onListAddClick"
          @onRecordClick="onSourceRecordClick"
      />
    </div>

    <div id="selected-source" v-if="!!activeSource">
      <div id="source-tags-panel">
        <div id="source-content-tags">
          <div class="source-header flex-2to1">
            <div>
              <h5 id="source-name">{{`${activeSource.first_name || ''} ${activeSource.last_name || ''} mentions for ${activeOrganization.name}`}}</h5>
            </div>

            <div class="source-add-btn align-right">
              <button class="btn btn-carma btn-sm" v-on:click="onAddSourceMentionClick">{{$t('sources.add_source_quote')}}</button>
            </div>
          </div>

          <div id="source-mention" v-if="sourceMention && sourceMention.mentions">
            <div v-for="(mention, index) in sourceMention.mentions" :key="index"
                 :id="'source-mention-' + index"
                 :class="{'source-mention-entry': true, active: index === activeQuoteIndex}"
                 v-on:click="onSourceMentionQuoteClick(index)"
            >

              <div class="source-form form-control">
                <textarea name="quote"
                          :ref="'sourceQuote'+index"
                          class="input-ui source-mention-quote"
                          @input="(event) => onSourceMentionQuoteChange(event.target.value, index)"
                          :value="mention.quote"></textarea>
                <div class="icon-btn icon-delete fas fa-times" v-on:click="(event) => deleteSourceMentionQuote(event, index)"></div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <app-form-modal
      v-if="showNewSourceModal"
      id="edit-record-form"
      large="true"
      title="sources.add_source_header"
      :fields="['title', 'first_name', 'last_name', 'job_title', 'affiliation_id', 'cat_id']"
      :fieldsAdditions="addFieldsAdditions"
      :errors="sourcesErrors"
      errors-type="source"
      @onSave="submitNewSource"
      @closeModal="closeNewSourceModal"
    />
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import _ from 'lodash';

  import List from './list';
  import FormModal from '../form-modal';

  import { FIELD_TYPE, VALIDATIONS, TAG_CATEGORY } from '../../config/const';

  export default {
    props: {
      activeOrganization: {
        type: Object,
        default: () => { return undefined }
      }
    },
    components: {
      'app-list': List,
      'app-form-modal': FormModal
    },
    computed: {
      ...mapState({
        sourcesPagination: state => state.sources.sources.pagination,
      }),
      ...mapState('source', [
        'source'
      ]),
      ...mapState('sources', [
        'sources'
      ]),
      ...mapState('affiliations', [
        'affiliations'
      ]),
      ...mapState('sourceCategories', [
        'sourceCategories'
      ]),
      ...mapGetters('source', ['sourcesErrors']),
      projectId() {
        return this.$route.params.project_id;
      },
      updatedSourceMentions () {
        return this.organizationMentions.find(mention => mention.id === this.activeSource.id);
      },
      sourcesData() { return this.sources && this.sources.data ? this.sources.data : [] },
      searchFields () {
        return {
          first_name: {
            type: FIELD_TYPE.INPUT,
            label: this.$i18n.t('sources.first_name'),
            id: this.listType + '-search-first-name',
            name: 'first_name',
            style: 'flex-basis: 100%'
          },
          last_name: {
            type: FIELD_TYPE.INPUT,
            label: this.$i18n.t('sources.last_name'),
            id: this.listType + '-search-last-name',
            name: 'last_name',
            style: 'flex-basis: 100%',
          },
          job_title: {
            type: FIELD_TYPE.INPUT,
            label: this.$i18n.t('sources.job_title'),
            id: this.listType + '-search-job-title',
            name: 'job_title',
            style: 'flex-basis: 100%'
          },
          affiliation: {
            type: FIELD_TYPE.SELECT,
            label: this.$i18n.t('sources.affiliation.title'),
            id: this.listType + '-search-affiliation',
            name: 'affiliation',
            options: this.affiliations && this.affiliations.data || [],
            searchable: true,
            optionsLimit: 100,
            dropdownDirection: 'bottom',
            placeholder: this.$i18n.t('sources.affiliation.select'),
            hideSelected: true,
            style: 'flex-grow: 1',
            customLabel: this.displayLabel,
            trackBy: 'value',
            customClass: 'mr10',
            multiple: true
          },
          cat_id: {
            type: FIELD_TYPE.SELECT,
            label: this.$i18n.t('sources.category.title'),
            id: this.listType + '-category',
            name: 'cat_id',
            options: this.sourceCategories && this.sourceCategories.data || [],
            searchable: true,
            optionsLimit: 100,
            dropdownDirection: 'bottom',
            placeholder: this.$i18n.t('sources.category.select'),
            hideSelected: false,
            style: 'flex-grow: 1',
            customLabel: this.displayLabel,
            trackBy: 'value'
          }
        }
      },
      addFieldsAdditions () {
        return {
          title: {
            type: FIELD_TYPE.SELECT,
            translatePlaceholder: 'sources.select_title',
            style: 'flex-grow: 1; order: 1;',
            customClass: 'mr10',
            validate: []
          },
          first_name: {
            style: 'flex-grow: 3; order: 2;'
          },
          last_name: {
            style: 'flex-basis: 100%; order: 3;'
          },
          job_title: {
            style: 'flex-basis: 100%; order: 4;'
          },
          affiliation_id: {
            options: this.affiliationList,
            searchable: true,
            optionsLimit: 100,
            dropdownDirection: 'top',
            placeholder: this.$i18n.t('sources.affiliation.select'),
            hideSelected: false,
            style: 'flex-grow: 1; order: 5;',
            customClass: 'mr10',
            customLabel: this.displayLabel,
            trackBy: 'value',
            taggable: true,
            tagPlaceholder: "Press enter to create affiliation",
            onTag: (e) => this.onTag(e),
            validate: [VALIDATIONS.REQUIRED]
          },
          cat_id: {
            placeholder: this.$i18n.t('sources.category.select'),
            style: 'flex-grow: 1; order: 6;',
            customLabel: this.displayLabel,
            validate: [VALIDATIONS.REQUIRED],
            options: this.sourceCategories && this.sourceCategories.data || []
          }
        }
      }
    },
    mounted () {
      this.loadSources();

      if (!this.affiliations.isBusy) {
        this.getAffiliations({
          projectId: this.projectId
        });
      }

      if (!this.sourceCategories.isBusy) {
        this.getSourceCategories({
          projectId: this.projectId
        });
      }

      this.organizationMentions = this.activeOrganization && this.activeOrganization.tags;
    },
    watch: {
      "activeOrganization.tags" () {
        if(this.activeOrganization && !_.isEqual(this.activeOrganization.tags, this.organizationMentions)) {
          this.organizationMentions = this.activeOrganization && this.activeOrganization.tags;

          this.resetActiveSource();
          if(!this.updatedSourceMentions || this.activeQuoteIndex > this.updatedSourceMentions.mentions.length - 1) {
            this.setActiveQuote(this.doesSourceHasMentions() ? 0 : -1);
          }
        }
      },
      activeSource () {
        this.resetActiveSource();
        this.setActiveQuote(this.doesSourceHasMentions() ? 0 : -1);

        this.$emit('setActiveSource', this.activeSource);
      },
      activeQuoteIndex () {
        this.$emit('setActiveQuoteIndex', this.activeQuoteIndex);
      },
      "affiliations.data" () {
        this.affiliationList = _.cloneDeep(this.affiliations.data);
      },
      "source.isBusy": {
        handler (newValue, oldValue) {
          if (oldValue && !newValue) {
            this.onSearchSubmit();
          }
        },
        deep: true
      }
    },
    methods: {
      ...mapActions({
        'addSource': 'source/addSource',
        'getSources': 'sources/getSources',
        'getAffiliations': 'affiliations/getAffiliations',
        'getSourceCategories': 'sourceCategories/getSourceCategories'
      }),
      loadSources (filterValues = {}, pagination = {}) {
        if (!this.sources.isBusy) {
          if (!pagination.order) {
            pagination.order = this.defaultOrder;
            pagination.sort = 'asc';
          }

          this.getSources({
            projectId: this.projectId,
            filterValues: filterValues,
            pagination: pagination
          });
        }
      },
      displayLabel (option) {
        return `${option.label}`
      },
      onTag(e){
        this.affiliationList.unshift(e);
      },
      updateSearchModel (model) {
        this.searchModel = model;
      },
      onSearchSubmit (pagination = {}) {
        const filterValues = this.searchModel.searchQuery ? {} : this.searchModel;
        if (this.searchModel.searchQuery) {
          pagination.query = this.searchModel.searchQuery;
        }

        this.loadSources(this.clearFilter(filterValues), pagination);
      },
      clearFilter(filter) {
        if (filter.first_name === '') delete filter.first_name;
        if (filter.last_name === '') delete filter.last_name;
        if (filter.job_title === '') delete filter.job_title;
        if (filter.affiliation === null) delete filter.affiliation;
        if (filter.cat_id === null) delete filter.cat_id;

        return filter;
      },
      onListAddClick (e) {
        if(e) {
          e.preventDefault();
          e.stopPropagation();
        }

        this.showNewSourceModal = true;
      },
      closeNewSourceModal () {
        this.showNewSourceModal = false;
      },
      submitNewSource (source) {
        if (!this.source.isBusy) {
          this.addSource({
            projectId: this.projectId,
            source: {...source, affiliation: source.affiliation_id}
          })
            .then(response => {
              this.closeNewSourceModal();
            })
            .catch(response => {
              console.error('Error submit new souce')
            });
        }
      },

      doesSourceHasMentions (){
        return this.sourceMention && this.sourceMention.mentions && this.sourceMention.mentions.length > 0;
      },
      resetActiveSource () {
        this.sourceMention = _.cloneDeep(this.updatedSourceMentions);
      },
      delayFunction (callback, delayMs) {
        if(this.globalTimeout != null)
          clearTimeout(this.globalTimeout);

        this.globalTimeout = setTimeout(callback, delayMs);
      },
      setActiveQuote (index) {
        this.activeQuoteIndex = index;

        this.delayFunction(() => {
          this.focusTextArea();
        }, 50);
      },
      focusTextArea () {
        var quoteForm = document.getElementById('source-mention-' + this.activeQuoteIndex);

        if(quoteForm) {
          quoteForm.getElementsByClassName('source-mention-quote')[0].focus();
        }
      },
      onSourceMentionQuoteChange(quote, index) {
        this.sourceMention.mentions[index].quote = quote;

        this.delayFunction(() => this.saveSourceMentionsToClip(index), 500);
      },
      onSourceRecordClick (source) {
        if(!_.isUndefined(this.activeOrganization)) {
          const invalidMentions = this.validateQuotes();

          if (!invalidMentions || invalidMentions.length == 0) {
            this.activeSource = source;
          }
          else {
            this.focusWithError(invalidMentions);
          }
        }
      },
      onAddSourceMentionClick() {
        let invalidMention;
        //Check that current quote is valid
        if (this.activeQuoteIndex != -1) {
          invalidMention = this.validateQuotes(this.activeQuoteIndex);
        }

        if (!invalidMention) {
          this.addSourceMention();
        }
        else {
          this.focusWithError([this.activeQuoteIndex]);
        }
      },
      addSourceMention () {
        let mention = _.cloneDeep(this.sourceMention);
        if(_.isUndefined(mention)) {
          const currentSource = this.activeSource;
          const sourceName = currentSource.first_name + ' ' + currentSource.last_name;
          mention = {
            id: currentSource.id,
            name: sourceName,
            show_sentiment: currentSource.show_sentiment,
            category: TAG_CATEGORY.SOURCES,
            mentions: []
          };
        }
        //add new empty quote
        mention.mentions.push({quote: ''});

        this.sourceMention = mention;
        this.setActiveQuote(mention.mentions.length - 1);
      },
      deleteSourceMentionQuote (event, quoteIndex) {
        event.preventDefault();
        event.stopPropagation();

        if (quoteIndex !== this.activeQuoteIndex) {
          this.onSourceMentionQuoteClick(quoteIndex);
          return;
        }

        if(this.doesSourceHasMentions()) {
          this.clearAllErrors();

          //if mention is already saves to clip, delete from clip directly
          if(this.updatedSourceMentions && this.updatedSourceMentions.mentions[quoteIndex]) {
            this.$emit('deleteSourceQuote', { sourceId: this.activeSource.id, quoteIndex });
          }
          else {
            //else delete from local sourceMention.mentions
            this.sourceMention.mentions.splice(quoteIndex, 1);

            this.setActiveQuote(this.doesSourceHasMentions() ? 0 : -1);
          }
        }
      },
      onSourceMentionQuoteClick (quoteIndex) {
        if(quoteIndex === this.activeQuoteIndex)
          return;

        let invalidMention;
        if (this.activeQuoteIndex !== -1) {
          invalidMention = this.validateQuotes(this.activeQuoteIndex);
        }

        if (!invalidMention) {
          this.setActiveQuote(quoteIndex)
        }
        else {
          this.focusWithError([this.activeQuoteIndex]);
        }
      },
      saveSourceMentionsToClip (quoteIndex) {
        if (quoteIndex === this.activeQuoteIndex){
          //only save if source quotes are valid
          const invalidMentions = this.validateQuotes();
          if (!invalidMentions || invalidMentions.length == 0) {
            this.$emit('addMentionTag', this.sourceMention);
          }
          else {
            this.focusWithError(invalidMentions);
          }
        }
      },
      validateQuotes (quoteIndex) {
        this.clearAllErrors();

        //Validate single quote
        //this returns true or false
        if (!_.isUndefined(quoteIndex)) {
          return this.doesSourceHasMentions() && this.sourceMention.mentions[quoteIndex].quote.trim() === '';
        }

        //Validate all quotes
        //this returns an array of invalid indexes
        let invalidIndices = [];
        this.doesSourceHasMentions() && this.sourceMention.mentions.filter((mention, index) => {
          if(mention.quote.trim() === '') {
            invalidIndices.push(index);
          }
        });
        return invalidIndices;
      },
      focusWithError (invalidMentions) {
        //invalidMentions is an array with invalid indexes
        invalidMentions.map((mention, index) => {
          var quoteForm = document.getElementById('source-mention-' + mention);
          if(quoteForm) {
            const quoteTextArea = quoteForm.getElementsByClassName('source-mention-quote')[0];
            quoteTextArea.classList.add('has-error');

            if(index === 0) {
              this.setActiveQuote(mention);
            }
          }
        });
      },
      clearAllErrors () {
        const sourcesContentContainer = document.getElementById('sources-content');
        const elementsWithError = sourcesContentContainer.getElementsByClassName('has-error');

        Array.from(elementsWithError).forEach(element => {
          element.classList.remove('has-error');
        });
      },
      renderApproved (value) {
        const tooltipText = value ? this.$i18n.t('tooltip.approved') : this.$i18n.t('tooltip.pending_approval');
        const tooltipIcon = value ? "fas fa-check icon-green" : "far fa-clock icon-red";
        return `<div tooltip="${tooltipText}" class="inline-tooltip"><span class="${tooltipIcon}"></span></div>`
      }
    },
    data () {
      return {
        listType: 'sources',
        displayColumns: [
          { label: 'Title', value: 'title', width: '10%' },
          { label: 'First Name', value: 'first_name', width: '22.5%' },
          { label: 'Last Name', value: 'last_name', width: '22.5%' },
          { label: 'Job', value: 'job', width: '20%' },
          { label: 'Organization', value: 'affiliation', width: '20%' },
          { label: '', value: 'approved', width: '5%', customRenderer: (value) => this.renderApproved(value) }],
        showNewSourceModal: false,
        affiliationList: [],
        searchModel: {},
        organizationMentions: undefined,
        activeSource: undefined,
        activeQuoteIndex: -1,
        sourceMention: undefined,
        globalTimeout: null,
        defaultOrder: 'last_name'
      }
    }
  }
</script>

<style lang="scss">
  @import "../../styles/components/coding-ui/sources";
</style>